import React from 'react';
import Page from './Page';
import ReorderPlaylists from 'components/playlist/ReorderPlaylists';
import PlaylistsPage from './PlaylistsPage';
import DialogPage from './DialogPage';

const ReorderPlaylistsPage: React.FC = (props: any) => {
	let { isModal } = props;

	return (
		<>
			{isModal ? null : <PlaylistsPage />}

			<DialogPage title="Reorder Playlists" transition={true} dark goBackOnClose={!!isModal} goBackTo="/playlists">
				<ReorderPlaylists />
			</DialogPage>
		</>
	);
};

export default ReorderPlaylistsPage;
